<template>
    <div class='login_wrap'>
        <div class="main_wrap">
            <div class="vague_bg"></div>
            <div class="other_content">
                <div class="logo">
                    <i class="iconfont icon-maisiduowei"></i>
                </div>
                <el-tabs v-model="activeName">
                    <!-- 学号/职工号登录 -->
                    <el-tab-pane name="workNum">
                        <span slot="label"><i class="el-icon-user-solid">&nbsp;&nbsp;学号/职工号登录</i></span>
                        <el-form class="register" :model="loginForm1" :rules="loginRules1" ref="loginForm1" label-width="0px">
                            <div class="form_wrap flex-column-between">
                                <el-form-item prop="schoolId">
                                    <el-select v-model="loginForm1.schoolId" placeholder="选择学校">
                                        <template slot="prefix">
                                            <span>
                                                <i class="iconfont icon-xuexiao"></i>
                                            </span>
                                        </template>
                                        <el-option v-for="item in schoolList" :label="item.schoolName" :value="item.schoolId" :key="item.schoolId"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item prop="workNum">
                                    <el-input  v-model="loginForm1.workNum"  placeholder="职工号" prefix-icon="iconfont icon-yonghu"></el-input>
                                </el-form-item>
                                <el-form-item prop="researchDirection">
                                    <el-input placeholder="密码"  v-model="loginForm1.password" show-password prefix-icon="iconfont icon-suo1"></el-input>
                                </el-form-item>
                            </div>
                        </el-form>
                    </el-tab-pane>
                    <!-- 手机号登录 -->
                    <el-tab-pane name="phoneNum">
                        <span slot="label"><i class="el-icon-phone">&nbsp;&nbsp;手机号登录</i></span>
                        <el-form class="register" :model="loginForm2" :rules="loginRules2" ref="loginForm2" label-width="0px">
                            <div class="form_wrap flex-column-between">
                                <el-form-item prop="phone">
                                    <el-input v-model="loginForm2.phone" maxlength="11" placeholder="手机号" prefix-icon="iconfont icon-yonghu"></el-input>
                                </el-form-item>
                                <el-form-item prop="researchDirection">
                                    <el-input placeholder="密码"  v-model="loginForm2.password" show-password prefix-icon="iconfont icon-suo1"></el-input>
                                </el-form-item>
                            </div>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
                <div class="remember flex-between">
                    <el-switch  v-model="remember"  active-color="#002D72" active-text="记住密码" inactive-color="#EAECF0"></el-switch>
                    <el-button type="text"  class="button-hover" style="color:#FFA833" @click="forgetPwd">忘记密码</el-button>
                </div>
                <el-checkbox v-model="isRead"><div class="agreement_text">用户须知: <span @click="agreementVisible = true" class="mouse-hover" style="color:#FFA833">《平台用户隐私及使用协议》</span></div></el-checkbox>
                <div class="footer_btn">
                    <el-button  @click="toLogin">登录</el-button>
                    <el-button type="primary" @click="toRegister">新用户注册</el-button>
                </div>
            </div>
        </div>
        <div class="copyright">
            <div>Copyright ©2020-2022 The Project by MaxSwell.All Rights Reserved</div>
            <div><a href="https://beian.miit.gov.cn" target="_blank">蜀ICP备19041704号-2</a></div>
        </div>
        <!-- 用户协议 -->
       <el-dialog :visible.sync="agreementVisible" width="50%" :show-close="false" class="dialog_wrap" top="5%" center>
            <div class="agreement_dialog">
                <div  class="agreement_title">平台用户<span style="color:#F56C6C">知识产权与隐私安全协议</span> </div>
                <p>尊敬的用户，您好！您现在阅读的是<span style="color:#F56C6C">平台用户知识产权与隐私安全使用协议</span> ，根据本协议的规定为平台用户提供服务，本协议具有合同上的法律效力。<b>用户在注册或使用平台前请务必仔细阅读以下条款，一经注册或主动使用本网站的服务，即视为对本协议全部条款已充分理解并完全接受，且自愿受以下条款的约束。</b> 该平台所属公司有权根据新的需要，<b>修改或调整</b>部分协议条款，如本协议及规则有任何变更，将会及时<b>更新公布最新协议</b>，若用户不同意相关变更，应主动停止使用本平台的服务。<b>该平台知识产权属成都麦思多维科技有限公司所有</b>。</p>
                <div class="one_title"><b>一、平台对用户信息与隐私保护</b></div>
                <p>为了给您提供更准确、更有针对性的服务，本平台可能会以如下方式，使用您提交的个人信息。但本平台会以高度的勤勉义务对待这些信息，在未征得您许可的情况下，不会将这些信息对外公开或向第三方提供。</p>
                <div class="two_title"><b>1.个人信息与账号安全</b></div>
                <p>本平台需要您在自愿选择服务的情况下提供个人信息，以便向您提供更好的用户服务。所有原始键入的信息将引用为注册资料。如果因注册信息不真实而引起的问题，由您自行承担相应的后果。<b>禁止将您的帐号、密码，未经本公司许可，转让或出借予他人使用</b> 。如您发现您的帐号遭他人非法使用，应立即通知本平台。因黑客行为或用户的保管疏忽导致帐号、密码遭他人非法使用，本平台不承担责任。</p>
                <div class="two_title"><b>2.行为信息与使用记录</b></div>
                <p>当您使用本平台的服务时，服务器会自动记录一些用户使用信息，本软件均会遵照法律规定保护您的个人隐私信息，除可能脱敏使用数据分析供科研与教学用途外，不会与任何第三方平台进行个人信息商业交易和对外公开。</p>
                <div class="one_title">二、用户对平台知识产权保护</div>
                <p>自用户使用该平台起，自动就该平台使用及知识产权保护达成如下协议：</p>
                <p>1.用户承诺合法使用本平台提供的服务及网站内容，禁止从事任何可能违反中国现行的法律、法规、规章和政府规范性文件的行为或任何未经授权使用本平台的行为。</p>
                <p>2.用户在用户账号授权时间及范围内使用，支持用户进行科研、教学自主研究，不得在未经平台所属公司授权情况下用于商业用途。本平台所属公司保留中止或终止用户身份的权利。</p>
                <p>3.用户在使用该平台期间，不得以任何形式将平台技术及产权内容纰漏给第三方，不能有任何损害平台利益的情况发生。</p>
                <p>4.用户未经平台所属公司同意，不得将本人所拥有的平台账号及密码转让给第三方或授权给第三方使用。</p>
                <p><span style="color:#409EFF">如果您对以上协议的任何内容有任何疑问或建议，您可以通过服务支持邮箱msdw@maxsdsp.com </span> 或 微信公众号：麦思多维研究院  与我们联系。</p>
            </div>
            <div slot="footer" class="flex-around">
                <el-button @click="agreementVisible = false" type="primary">我已知晓</el-button>
            </div>
       </el-dialog>
    </div>
</template>

<script>
import { Base64 } from 'js-base64';
import {listWithRegisteredUser, login, getSchoolById} from '../../../utils/api'
export default {
    data () {
        return {
            isRead:false,
            activeName:'workNum',
            agreementVisible:false,
            remember:false,
            querySchoolName:'',
            loginForm1:{
                schoolId:'',
                workNum:'',
                password:''
            },
            loginForm2:{
                phone:'',
                password:''
            },
            loginRules1:{
                schoolId: [{ required: true, message: '请选择学校', trigger: 'blur' }],
                workNum: [{ required: true, message: '请输入学号/职工号', trigger: 'blur' }],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { pattern: /^.{8,}$/, message: '请输入8-16位密码，区分大小写', trigger: 'blur' }
                ],
            },
            loginRules2:{
                phone: [{ required: true, message: '请选择学校', trigger: 'blur' }],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { pattern: /^.{8,}$/, message: '请输入8-16位密码，区分大小写', trigger: 'blur' }
                ],
            },
            schoolList:[]
        }
    },
    created(){
        this.getSchoolList()
        
    },
    mounted(){
        this.getAccount()
    },
    methods:{
        // 获取学校列表
        getSchoolList(){
            listWithRegisteredUser().then(res => {
                this.schoolList = res.data
            }).catch(err => {})
        },

        //根据学校id获取学校名称(记住密码)
        getSchoolName(){
            getSchoolById(`${this.loginForm1.schoolId}`).then(res => {
                this.loginForm1.schoolId = res.data.schoolId
            })
        },

        //登录成功后公共操作
        commonActionLogin(res){
            // this.$message.success("登录成功")
            sessionStorage.setItem('token',res.token)
            this.$store.commit('setUserInfo',{
                schoolName:res.data.schoolName,//学校名
                roleName:res.data.roleName,//身份
                phone:res.data.phone,//手机号
                workNumber:res.data.workNumber,//学号
                userName:res.data.username,//用户名
            })
            this.$store.commit("setUserAvatar", {
                userAvatar:res.data.userAvatar,//头像
            });
            this.$store.commit('rememberKey',{
                isDefaultPassword : res.data.isDefaultPassword
            })
            let redirect = decodeURIComponent(this.$route.query.redirect || '/index')
            this.$store.commit('setRouterPath',{routerPath:redirect})
            this.$router.replace(redirect)
        },

        //登录
        toLogin(){
            if(!this.isRead) return this.$message.error('请先阅读知识产权与隐私安全协议！')
            // 职工号
            if(this.activeName == 'workNum'){
                this.$refs.loginForm1.validate(valid => {
                    if(!valid) return
                    let { schoolId, workNum, password } = this.loginForm1
                    let paramsWork = {
                        loginMethod : 0,
                        schoolId,
                        workNum,
                        password
                    }
                    login(paramsWork).then(res => {
                        this.remember && this.setCookie('', '', this.loginForm1.schoolId, this.loginForm1.workNum, this.loginForm1.password, 30)
                        if(res.code == 200){
                           this.commonActionLogin(res)
                        }
                    }).catch(err => {})
                })
            }else{  //账号
                this.$refs.loginForm2.validate(valid => {
                    if(!valid) return
                    let { phone, password } = this.loginForm2
                    let paramsPhone = {
                        loginMethod : 1,
                        phone,
                        password
                    };
                    login(paramsPhone).then(res => {
                        this.remember && this.setCookie(this.loginForm2.phone, this.loginForm2.password, '', '', 30)
                        if(res.code == 200){
                            this.commonActionLogin(res)
                        }
                    }).catch(err => {})
                })
            }
        },

        //获取账号信息，从cookie解密decode
        getAccount(){
            // 读取cookie 将用户名和密码回显到input框中
            if (document.cookie.length > 0) {
                let arr = document.cookie.split(';')// 这里显示的格式需要切割一下自己可输出看下
                for (let i = 0; i < arr.length; i++) {
                    let arr2 = arr[i].split('=')// 再次切割
                    // 去掉属性空格
                    arr2[0] = arr2[0].replace(/\s*/g,"")
                    // 判断查找相对应的值
                    if (arr2[0] == 'phoneNum') {
                        this.loginForm2.phone = arr2[1]// 保存到保存数据的地方
                        // 其中unescape() 方法是将字符串进行编码，escape()方法是将字符串进行解码。
                    }else if (arr2[0] == 'userPwd') {
                        this.loginForm2.password = Base64.decode(arr2[1]) 
                    }else if (arr2[0] == 'schoolId') {
                        this.loginForm1.schoolId = arr2[1]
                        this.loginForm1.schoolId && this.getSchoolName() 
                    }else if (arr2[0] == 'workNum') {
                        this.loginForm1.workNum = arr2[1] 
                    }else if (arr2[0] == 'userPwd1') {
                        this.loginForm1.password = Base64.decode(arr2[1]) 
                    }
                }
            }
            if(this.loginForm2.phone || this.loginForm1.phone){
                this.remember = true
            }
        },
        
        //记住密码，写入账号信息，并且encode加密
        setCookie(phone, pwd,schoolId, work, pwd1, exdays){
            // 读取cookie 将用户名和密码回显到input框中
            let exdate = new Date()// 获取时间
            exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays)// 保存的天数
            // 字符串拼接cookie
            window.document.cookie = `phoneNum=${phone};path=/;expires=${exdate.toGMTString()}`
            window.document.cookie = `userPwd=${Base64.encode(pwd)};path=/;expires=${exdate.toGMTString()}`
            window.document.cookie = `schoolId=${schoolId};path=/;expires=${exdate.toGMTString()}`
            window.document.cookie = `workNum=${work};path=/;expires=${exdate.toGMTString()}`
            window.document.cookie = `userPwd1=${Base64.encode(pwd1)};path=/;expires=${exdate.toGMTString()}`
        },

        // 跳转忘记密码页面
        forgetPwd(){
            this.$router.push('/resetPassword')
        },

        //跳转注册
        toRegister(){
            this.$router.push('/register')
        }
    }
}
</script> 

<style lang='scss' scoped>
.agreement_text{
    color:white;
    margin:10px 0px
}
.dialog_wrap{
    /deep/.el-dialog{
        border-radius: 10px;
        overflow: hidden;
    }
    /deep/.el-dialog__header{
        padding: 0px;
    }
}

.agreement_dialog{
    line-height: 1.7;
    font-size: 18px;
    max-height: 70vh;
    overflow-y: auto;
    padding: 20px 50px;
    .agreement_title{
        font-size: 25px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 20px;
    }
    .one_title{
        margin: 10px 0px;
    }
    p{
        text-indent: 2rem;
    }
}
/deep/.el-switch__label{
    color: white;
}
.footer_btn{
    width: 100%;
    /deep/ .el-button{
        width: 48%;
        margin-top: 20px;
    }
}
.register{
    margin-top: 20px;
}
.copyright{
    position: absolute;
    bottom: 15px;
    width: 100%;
    padding: 0px 30%;
    display: flex;
    color: white;
    box-sizing: border-box;
    justify-content: space-around;
    a{
        color: white;
    }
    a:hover{
        opacity: 0.8;
    }
}
.login_wrap{
    height: 100vh;
    width: 100vw;
    box-sizing: border-box;
    background: url(../../../assets/img/MS-A/bg.png) 0 0/100% 100% no-repeat;
    display: flex;
    align-items: center;
    .main_wrap {
        width: 530px;
        // height: 600px;
        position: absolute;
        top: 150px;
        right: 200px;
        padding: 65px 70px;
        z-index: 10;
        // background: rgba(255,255,255,0.39);
        // filter: blur(40px);
        overflow: hidden;
        box-sizing: border-box;
        .vague_bg{
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 2;
            // background: url(../../../assets/img/MS-A/glass_bg.png) 0 0/100% 100% no-repeat;
            background: rgba(250, 250, 250, 0.20);
            backdrop-filter: blur(30px);
        }   
        .other_content{
            position: relative;
            z-index: 5;
        }
        .logo{
            width: 100%;
            height: 150px;
            text-align: center;
            line-height: 150px;
            // margin-bottom: 30px;
            .icon-maisiduowei{
                font-size: 55px;
                color: white;
            }
        }
        /deep/.el-input{
            box-sizing: border-box;
            background: #002D72;
            border-radius: 30px;
            /deep/.el-input__inner{
                background: #002D72;
            }
        }
        
        /deep/.el-tabs__item{
            box-sizing: border-box;
            padding: 0px;
            width: 50%;
            text-align: center;
            color: #CCCCCC;
        }
        /deep/.is-active{
            color: white;
        }
        /deep/.el-tabs__nav{
            width: 100%;
            position: relative;
            
        }
    }
}    
</style>